document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.image-carousel').forEach((el) => {
    const wrapper = el.closest('.slider-wrapper');
    const slidesPerView = parseFloat(el.dataset.slidesPerView) || 1;
    const effect = el.dataset.transition || 'slide';
    const spaceBetween = parseInt(el.dataset.space) || 0;
    const autoplay = el.dataset.autoplay === '1';
    const arrows = el.dataset.arrows === '1';
    const pagination = el.dataset.pagination === '1';
    const centerMode = el.dataset.center === '1';
    const loop = el.dataset.loop ==='1';

    new Swiper(el, {
      slidesPerView,
      effect,
      spaceBetween,
      loop,
      centeredSlides: centerMode,
      autoplay: autoplay ? { delay: 3000 } : false,
      pagination: pagination ? {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      navigation: arrows ? {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      } : false,
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.testimonial-carousel').forEach((el) => {
    const wrapper = el.closest('.slider-wrapper');
    const slidesPerView = parseFloat(el.dataset.slidesPerView) || 1;
    const effect = el.dataset.transition || 'slide';
    const spaceBetween = parseInt(el.dataset.space) || 0;
    const autoplay = el.dataset.autoplay === '1';
    const arrows = el.dataset.arrows === '1';
    const pagination = el.dataset.pagination === '1';
    const centerMode = el.dataset.center === '1';
    const loop = el.dataset.loop ==='1';

    new Swiper(el, {
      autoHeight: true,
      slidesPerView,
      effect,
      spaceBetween,
      loop,
      centeredSlides: centerMode,
      autoplay: autoplay ? { delay: 6000 } : false,
      pagination: pagination ? {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      navigation: arrows ? {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      } : false,
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.event-carousel').forEach((el) => {
    const wrapper = el.closest('.slider-wrapper');
    const slidesPerView = parseFloat(el.dataset.slidesPerView) || 1;
    const effect = el.dataset.transition || 'slide';
    const spaceBetween = parseInt(el.dataset.space) || 0;
    const autoplay = el.dataset.autoplay === '1';
    const arrows = el.dataset.arrows === '1';
    const pagination = el.dataset.pagination === '1';
    const centerMode = el.dataset.center === '1';
    const loop = el.dataset.loop === '1';
    const isFade = effect === 'fade';

    if (isFade) el.classList.add('is-fade');

    const swiper = new Swiper(el, {
      autoHeight: false,
      slidesPerView,
      effect,
      spaceBetween,
      loop,
      centeredSlides: centerMode,
      autoplay: autoplay ? { delay: 6000 } : false,
      speed: 400,
      ...(isFade ? { fadeEffect: { crossFade: true } } : {}),
      pagination: pagination && wrapper ? {
        el: wrapper.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      navigation: arrows && wrapper ? {
        nextEl: wrapper.querySelector('.swiper-button-next'),
        prevEl: wrapper.querySelector('.swiper-button-prev'),
      } : false,
    });

    if (isFade) {
      const syncHeight = () => {
        const tallest = Math.max(...swiper.slides.map((s) => s.scrollHeight));
        el.style.setProperty('--fade-height', `${tallest}px`);
      };
      syncHeight();
      swiper.on('breakpoint', syncHeight);
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncHeight, 150);
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.marquee-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    allowTouchMove: true,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });
});